import React from "react";
import Layout from "@app/Layout";
import Canonical from "@shared/head/Canonical";
import Breadcrumbs from "@shared/head/Breadcrumbs";
import { UseCase } from "@features/custom-chatbot/UseCase";

import {
  heroData,
  featureData,
  sectionsData,
  relatedData,
} from "@shared/arrays/custom-chatbot-collect-your-leads-even-when-your-team-is-sleeping";

export const Head = () => (
  <>
    <html lang="en" />
    <title>24/7 lead capture chatbot template | Dashly</title>
    <meta name="description" content="Don't lose night-time visitors. Dashly's after-hours chatbot qualifies leads and hands them to agents when the team is back online." />
    <Canonical url="https://www.dashly.io/custom-chatbot/collect-your-leads-even-when-your-team-is-sleeping/" />
    <Breadcrumbs
      list={[
        { name: "Dashly", url: "https://www.dashly.io/" },
        { name: "Custom chatbot", url: "https://www.dashly.io/custom-chatbot/" },
        {
          name: "24/7 lead capture",
          url: "https://www.dashly.io/custom-chatbot/collect-your-leads-even-when-your-team-is-sleeping/",
        },
      ]}
    />
  </>
);

export default function Page() {
  return (
    <Layout className="new-design">
      <UseCase
        title={heroData.title}
        subtitle={heroData.subtitle}
        feature={featureData}
        sections={sectionsData}
        related={relatedData}
      />
    </Layout>
  );
}
